import { PreconfiguredMessageInterface } from '@rsos/reduxDataStore/src/features/alerts/chat.types';

export const getMatchingPreconfigured = (
  preconfiguredMessages: PreconfiguredMessageInterface[],
  searchedMessage: string,
) => {
  return preconfiguredMessages.filter(preconfiguredMessage => {
    const lowerSearchedMessage = searchedMessage.toLowerCase();

    const isMatchingTitle = preconfiguredMessage.title
      .toLowerCase()
      .includes(lowerSearchedMessage);

    const isMatchingMessage = preconfiguredMessage.body
      .toLowerCase()
      .includes(lowerSearchedMessage);

    return isMatchingMessage || isMatchingTitle;
  });
};
